import BCA from "public/static/images/svg/bank/bca.svg";
import Mandiri from "public/static/images/svg/bank/mandiri_ic.svg";
import BNI from "public//static/images/svg/bank/bni.svg";
import BRI from "public/static/images/svg/bank/bri_ic.svg";
import ATMBersama from "public/static/images/svg/bank/atm_bersama.svg";
import BTPN from "public/static/images/png/BTPN-Logo-Primary.png";
import Danamon from "public//static/images/png/danamon.png";

export const TransferBankData = [
  {
    icon: BCA,
    title: "bca",
    sections: [
      {
        title: "Pembayaran melalui ATM BCA",
        steps: [
          "Pilih menu <b>TRANSFER</b>",
          "Pilih menu <b>DARI REKENING TABUNGAN</b>",
          "Pilih tujuan transfer <b>KE REKENING BCA VIRTUAL ACCOUNT</b>",
          "Ketik kode bank <b>11281</b>, diikuti 10 digit nomor kontrak, pilih <b>TEKAN JIKA BENAR</b>",
          "Ketik jumlah pembayaran, pilih <b>TEKAN JIKA BENAR</b>",
          "Jika transaksi berhasil, muncul halaman konfirmasi, pilih <b>TEKAN JIKA YA</b>",
        ],
      },
      {
        title: "Pembayaran melalui mBCA",
        steps: [
          "Masukkan ke dalam m-Banking BCA lalu pilih <b>M-TRANSFER</b>",
          "Pilih <b>BCA VIRTUAL ACCOUNT</b> dalam menu m-transfer",
          "Pilih <b>INPUT NO. VIRTUAL ACCOUNT</b>",
          "Ketik kode bank <b>11281</b> diikuti 10 digit nomor kontrak, lalu pilih <b>OK</b>",
          "Setelah nomor Virtual Account sudah masuk, tekan <b>SEND</b>",
          "Layar akan menampilkan konfirmasi pembayaran, pilih <b>OK</b>",
          "Ketik jumlah pembayaran pada kolom total tagihan",
          "Ketik keterangan pada kolom berita jika ada, atau langsung pilih <b>OK</b>",
          "Masukkan pin <b>m-BCA</b>",
          "Jika transaksi berhasil, layar akan menunjukkan konfirmasi pembayaran",
        ],
      },
      {
        title: "Pembayaran melalui KlikBCA",
        steps: [
          "Login ke <b>KlikBCA</b>",
          "Pilih menu <b>TRANSFER</b>",
          "Transfer ke Rekening Virtual kamu, ketik kode bank <b>11281</b> diikuti 10 digit nomor kontrak. Pastikan nama perusahaannya adalah <b>HOME CREDIT INDONESIA</b>",
          "Isi jumlah pembayaran dan <b>RESPON KeyBCA</b>",
          "Cetak, simpan, atau kirim bukti pembayaran melalui email",
        ],
      },
    ],
  },
  {
    icon: Mandiri,
    title: "mandiri",
    sections: [
      {
        title: "Pembayaran melalui ATM Mandiri",
        steps: [
          "Pilih menu <b>BAYAR/BELI</b>, lalu pilih <b>ANGSURAN</b>",
          "Ketik kode perusahaan <b>88420</b>, pilih <b>BENAR</b>",
          "Ketik <b>88420</b> diikuti 10 digit no. kontrak, pilih <b>BENAR</b>",
          "Ketik jumlah pembayaran yang akan ditransfer, lalu pilih <b>BENAR</b>",
          "Di halaman konfirmasi, pilih nomor 1 kemudian pilih <b>BENAR</b>",
          "Akan muncul konfirmasi tagihan di layar ATM, jika sudah selesai pilih <b>BENAR</b>",
        ],
      },
      {
        title: "Pembayaran melalui Mandiri i-Banking",
        steps: [
          "Masuk Internet Banking Mandiri<br/><span>> Pilih <b>BAYAR</b></span><br/><span>> Pilih <b>ANGSURAN</b></span>",
          "Pilih nomor rekening pengirim",
          "Pilih <b>PT HOME CREDIT INDONESIA</b> dari menu <b>PENYEDIA JASA</b>",
          "Ketik kode bank <b>88420</b> diikuti 10 digit nomor kontrak",
          "Masukkan jumlah yang akan dibayarkan di kolom <b>NOMINAL</b>, lalu pilih <b>LANJUTKAN</b>",
          "Jika data sudah benar, tekan kotak pada total tagihan yang akan dibayarkan untuk memilih tagihan",
          "Masukkan PIN Mandiri dengan memasukkan challange code ke token Mandiri, lalu tekan <b>KIRIM</b>",
          "Jika Transaksi berhasil, cetak bukti pembayaran",
        ],
      },
      {
        title: "Pembayaran melalui Mandiri M-Banking",
        steps: [
          "Pilih menu <b>BAYAR</b>",
          "Pilih <b>ANGSURAN</b>",
          "Pilih penyedia institusi <b>PT HOME CREDIT INDONESIA</b>",
          "Masukkan nomor Mandiri Virtual Account <b>88420</b> diikuti 10 digit nomor kontrak",
          "Masukkan <b>NOMINAL</b> pembayaran",
          "Pada layar konfirmasi, pastikan data dan nominal sudah sesuai",
          "Jika sudah sesuai, masukkan, <b>mPIN MANDIRI ONLINE</b>, lalu klik <b>OK</b>",
          "Transaksi Selesai",
        ],
      },
    ],
  },
  {
    icon: BNI,
    title: "bni",
    sections: [
      {
        title:
          '<span style="color: var(--color-red); font-weight: normal;">* Pembayaran Uang Muka Tidak Tersedia di BNI.</span> <br><br> Pembayaran melalui ATM BNI',
        steps: [
          "Pilih <b>MENU LAINNYA</b>",
          "Pilih <b>TRANSFER</b>",
          "Pilih <b>JENIS REKENING</b>",
          "Pilih <b>VIRTUAL ACCOUNT BILLING</b>",
          "Masukkan nomor <b>VIRTUAL ACCOUNT ANDA</b> (800420 + 10 Angka Nomor Kontrak, contoh : 8004203800123456)",
          "Klik <b>BENAR</b>",
          "Pastikan nomor <b>VIRTUAL ACCOUNT</b> dan <b>NAMA ANDA</b> sudah sesuai",
          "Masukkan nominal yang akan dibayarkan lalu klik <b>LANJUTKAN</b>",
        ],
      },
      {
        title: "Pembayaran melalui BNI i-Banking",
        steps: [
          "Daftarkan rekening bank:<br/><span >> Pilih <b>TRANSFER</b> lalu pilih <b>TAMBAH REKENING FAVORIT</b></span><br/><span >> Pilih menu <b>INFO & ADMINISTRASI TRANSFER</b></span><br/><span >> Pilih <b>ATUR REKENING TUJUAN</b></span><br/><span >> Pilihlah <b>TAMBAH REKENING TUJUAN</b>, klik <b>OK</b></span>",
          "Isi:<br/><span >> Kode Network & Bank: Transfer Antar Rek.BNI</span><br/><span >> Nomor Rekening: Ketik <b>800420</b> diikuti 10 digit nomor kontrak</span><br/><span >> Klik <b>LANJUT</b></span><br/><span >> Klik <b>LANJUTKAN</b></span>",
          "Masukkan kode otentikasi token, pilih <b>PROSES</b>:",
          "Pembayaran<br/><span >> Pilih menu <b>TRANSFER</b></span><br/><span >> Pilih menu <b>TRANSFER ANTAR REKENING BNI</b></span>",
          "Pilih rekening sumber pembayaran<br/><span >> Pilih rekening tujuan</span><br/><span >> Kemudian pilih <b>REKENING DEBET</b> dan ketik jumlah pembayaran</span>",
          "Masukkan kode otentikasi token, kemudian tekan <b>LANJUT</b>",
          "Transfer telah berhasil, simpan bukti transfer sebagai bukti pembayaran",
        ],
      },
      {
        title: "Pembayaran melalui BNI M-Banking",
        steps: [
          "Pilih <b>TRANSFER</b>",
          "Pilih <b>VIRTUAL ACCOUNT BILLING</b>",
          "Masukkan nomor <b>VIRTUAL ACCOUNT ANDA</b> (800420 + 10 Angka nomor Kontrak, contoh : 80042000123456)",
          "Masukkan <b>NOMINAL PEMBAYARAN</b>",
          "Konfirmasi <b>TRANSAKSI</b> dan Masukkan <b>PASSWORD</b> Transaksi",
          "Transaksi Anda selesai",
        ],
      },
    ],
  },
  {
    icon: BRI,
    title: "bri",
    sections: [
      {
        title: "Pembayaran melalui ATM BRI",
        steps: [
          "Pilih <b>TRANSAKSI LAIN</b>",
          "Pilih <b>PEMBAYARAN</b>",
          "Pilih <b>LAINNYA</b>",
          "Pilih <b>BRIVA</b>",
          "Masukkan kode bank <b>88420</b> diikuti 10 digit nomor kontrak, kemudian muncul layar konfirmasi, pilih <b>BENAR</b> jika informasinya sudah benar",
          "Masukkan jumlah pembayaran, kemudian muncul layar informasi, pilih <b>YA</b> jika konfirmasi sudah benar",
          "Masukkan jumlah pembayaran, pilih <b>BENAR</b>",
          "Pilih <b>YA</b>",
        ],
      },
      {
        title: "Pembayaran melalui BRI i-Banking",
        steps: [
          "Masuk ke internet banking BRI",
          "Pilih <b>PEMBAYARAN & PEMBELIAN</b>",
          "Pilih <b>PEMBAYARAN TAGIHAN</b>",
          "Pilih <b>BRIVA</b>",
          "Pilih Rekening dari Menu Rekening",
          "Isi kode bayar dengan nomor BRI Virtual Account <b>88420</b> diikuti 10 angka nomor kontrak, lalu tekan <b>KIRIM</b>",
          "Masukkan Password dan PIN yang didapat dari token BRI, lalu tekan <b>KIRIM</b>",
          "Jika transaksi berhasil, cetak atau simpan bukti pembayaran",
        ],
      },
      {
        title: "Pembayaran melalui BRI M-Banking",
        steps: [
          "Lakukan <b>LOG IN</b> dengan akun BRI Mobile Banking",
          "Pilih menu <b>PEMBAYARAN</b>, kemudian pilih <b>BRIVA</b>",
          "Masukkan nomor BRI Virtual Account <b>88420</b> diikuti 10 digit nomor kontrak, kemudian masukkan jumlah nominal yang akan dibayar",
          "Masukkan PIN Mobile Banking BRI",
          "Transaksi Selesai",
        ],
      },
    ],
  },
  {
    icon: ATMBersama,
    title: "bersama",
    sections: [
      {
        title: "Pembayaran melalui ATM Bersama",
        steps: [
          "Pilih Menu <b>TRANSFER</b>",
          "Pilih <b>DARI REKENING TABUNGAN</b>",
          "Pilih <b>KE REKENING BANK LAIN</b>",
          "Masukkan angka <b>0138462</b> dan 10 digit nomor kontrak pilih kontrak pilih <b>TEKAN JIKA BENAR</b>",
          "Jika informasi sudah benar, pilih TEKAN JIKA YA",
        ],
      },
    ],
  },
  {
    icon: BTPN,
    title: "btpn",
    sections: [
      {
        title: "Pembayaran melalui ATM BTPN",
        steps: [
          "Pilih menu <b>LAIN</b>",
          "Pilih menu <b>TRANSFER</b>",
          "Pilih menu <b>REKENING NASABAH LAIN</b>",
          "Pilih <b>TABUNGAN</b>",
          "Masukkan nomor <b>8000005</b>, diikuti 10 digit angka kontrak",
          "Masukkan nominal pembayaran",
          "Konfirmasi transaksi",
        ],
      },
      {
        title: "Pembayaran melalui Jenius",
        steps: [
          "Log in",
          "Pilih menu <b>SEND IT</b>",
          "Tambah Penerima",
          "Pilih Bank BTPN",
          "Masukkan <b>8000005</b>, diikuti 10 digit angka kontrak",
          "Masukkan nominal pembayaran ",
          "Masukkan PIN",
        ],
      },
    ],
  },
  {
    icon: Danamon,
    title: "btpn",
    sections: [
      {
        title: "Pembayaran melalui Aplikasi D-Bank PRO",
        steps: [
          "Login ke Aplikasi D-Bank PRO",
          "Pilih Menu <b>VIRTUAL ACCOUNT</b>",
          "Pilih <b>TUJUAN PEMBAYARAN</b>",
          "Jika nomor virtual account belum pernah disimpan, pilih <b>+Tagihan Baru</b> untuk masukkan nomor virtual account",
          "Masukkan <b>919100 + nomor kontrak</b> kamu lalu klik <b>LANJUT</b>",
          "Pastikan Rekening Sumber Dana dan Tujuan Pembayaran sesuai lalu klik <b>LANJUT</b>",
          "Isi dan pastikan informasi pembayaran dengan virtual account sesuai, masukkan mPIN lalu klik <b>KIRIM</b>",
        ],
      },
      {
        title: "Pembayaran melalui Website D-Bank PRO ",
        steps: [
          "Login ke website D-Bank PRO <b>(www.dbank.co.id)</b>",
          "Pilih menu <b>VIRTUAL ACCOUNT</b>",
          "Pilih <b>TUJUAN PEMBAYARAN</b>",
          "Jika nomor virtual account belum pernah disimpan, pilih <b>+Tagihan Baru</b> untuk masukkan nomor virtual account",
          "Masukkan <b>919100 + nomor kontrak</b> kamu lalu klik <b>LANJUT</b>",
          "Pastikan Rekening Sumber Dana dan Tujuan Pembayaran sesuai lalu klik <b>LANJUT</b>",
          "Isi dan pastikan informasi pembayaran dengan virtual account sesuai, masukkan mPIN lalu klik <b>KIRIM</b>",
        ],
      },
      {
        title: "Pembayaran melalui ATM Danamon (menu Pembayaran)",
        steps: [
          "Pilih menu Pembayaran, pilih <b>Lainnya</b>, lalu pilih <b>VIRTUAL ACCOUNT</b>",
          "Masukkan <b>919100 + nomor kontrak</b> kamu lalu klik <b>BENAR</b>",
          "Pilih rekening sumber dana",
          "Masukkan jumlah pembayaran atau konfirmasi tagihan",
        ],
      },
      {
        title: "Pembayaran melalui ATM Danamon (menu Transfer Dana)",
        steps: [
          "Pilih menu Transfer Dana, lalu pilih rekening Bank Danamon",
          "Masukkan <b>919100 + nomor kontrak</b> kamu lalu klik <b>BENAR</b>",
          "Masukkan jumlah pembayaran lalu pilih <b>BENAR</b>",
          "Pilih rekening sumber dana",
          "Cek konfirmasi pembayaran, jika sudah benar pilih <b>YA</b>",
        ],
      },
    ],
  },
];
